<template>
  <div
    class="fixed z-10 top-0 left-0 flex items-center justify-center w-screen h-screen bg-gray-600/50 transition-all ease-in duration-75"
    :class="{
      'opacity-0 invisible pointer-events-none scale-75': !isVisible,
    }"
  >
    <div class="px-10 py-5 bg-white dark:bg-gray-800 rounded-lg w-auto">
      <div class="flex items-center text-gray-700 dark:text-gray-100 mt-2 mb-4 ml-2">
        Are you sure you want to reject all Speakers?
      </div>
      <div class="flex justify-center gap-4 mt-2">
        <button
          @click="confirm"
          class="px-4 py-2 text-sm font-semibold text-white bg-red-500 shadow leading-6 rounded-md hover:bg-red-600 transition ease-in-out duration-150"
        >
          Yes
        </button>
        <button
          @click="cancel"
          class="px-4 py-2 text-sm font-semibold text-gray-700 bg-gray-100 dark:bg-gray-700 dark:text-gray-300 shadow leading-6 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 transition ease-in-out duration-150"
        >
          No
        </button>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    name: 'RejectAllSpeakersModal',
    props: {
      isVisible: {
        type: Boolean,
        required: true
      }
    },
    emits: ['update:isVisible', 'confirm'],
    methods: {
      confirm() {
        this.$emit('confirm')
        this.$emit('update:isVisible', false)
      },
      cancel() {
        this.$emit('update:isVisible', false)
      }
    }
  }
  </script>